import axios from "axios";
import settings from "utils/settings";

const apiUrl = `${settings.apiUrl}api/`;

export const requestCommonSearch = (controller, page = null, size = null, sort = null, criteria = [], customAPIURL = false) => {
  const params = [{
    key: "page",
    value: page
  }, {
    key: "size",
    value: size
  }, {
    key: "sort",
    value: sort
  }];

  const paramsString = params
    .filter(item => item.value !== null && typeof item.value !== "undefined")
    .map(item => `${item.key}=${item.value}`)
    .join("&");

  return axios
    .post(`${customAPIURL || apiUrl}${controller}/search?${paramsString}`, {
      criteria
    })
    .then(response => response.data.content);
};

export const requestCommonFilters = (controller, customAPIURL = false) =>
  axios.get(`${customAPIURL || apiUrl}${controller}/filters`)
    .then(response => ({
      data: {
        content: response.data.content.reduce((current, next) => {
          current[next.filedName] = next;
          return current;
        }, {})
      }
    }));

export const requestCommonDelete = (controller, id, customAPIURL) =>
  axios.delete(`${customAPIURL || apiUrl}${controller}/${id}`);



// WEBPACK FOOTER //
// ./src/actions/common/requests.js